/**
 * Global styles for CMS
 */
export default {
  COLOR_PRIMARY: 'hsl(160, 50%, 50%)',
  COLOR_ERROR: 'hsl(160, 40%, 45%)',
  COLOR_LINK: 'hsl(200, 50%, 70%)'
};
